/**
 * Product Hotspot constants.
 */
export const PRODUCT_HOTSPOT_CONSTANTS = {
	DEFAULT_DIAMETER_PERCENT: 15,
	DEFAULT_DIAMETER_PX: 48,
	MIN_PX: 10,
	MIN_PERCENT_FALLBACK: 5,
	BASE_WIDTH: 800,
	BASE_HEIGHT: 600,
};
